import { useParams } from "react-router-dom";
import { useQuery } from "../../utils/hooks";
import ConsentPreview from "./Builder/ConsentPreview/ConsentPreview";

const StudyConsentPreview = () => {
  const { id: studyId, formId } = useParams();
  const versionId = useQuery().get("versionId") || "";
  const formType = useQuery().get("formType") || "";

  return (
    <ConsentPreview
      studyId={studyId || ""}
      formId={formId || ""}
      versionId={versionId}
      type="study"
      editable={true}
      formType={formType as "consent" | "sunshine"}
    />
  );
};

export default StudyConsentPreview;
